import HighLevel from './HighLevelComponent';
import Summary from './SummaryComponent';
import TopSpendings from './TopSpendingsComponent';
import TopTags from './TopTagsComponent';
import TopUnused from './TopUnusedComponent';
import Events from './EventsComponent';

export default {
  HighLevel,
  Summary,
  TopSpendings,
  Events,
  TopTags,
  TopUnused
};



// WEBPACK FOOTER //
// ./src/components/high-level/index.js